import { useMutation, useQueryClient } from '@tanstack/react-query'

import { venueProfileQueryKey } from '@/hooks/useVenueProfile'
import type { ApiError } from '@/lib/api/errors'
import { createCourt } from '@/lib/venue/courtApi'
import type { CourtListView, CourtSaveInput } from '@/lib/venue/courtTypes'

import { courtsQueryKey } from './useCourts'

/**
 * 코트 등록 (#597 §2).
 *
 * 성공 시:
 *  ① 응답(= 등록 후 최신 목록)을 코트 쿼리 캐시에 **직접 반영**한다 — 재조회하지 않는다.
 *  ② 코트 수가 바뀌므로 구장 프로필 쿼리(요약·편집 화면의 "코트 수")를 무효화한다(설계 D3).
 */
export function useCreateCourt(venueId: string) {
  const queryClient = useQueryClient()

  return useMutation<CourtListView, ApiError, CourtSaveInput>({
    mutationFn: (input) => createCourt(venueId, input),
    onSuccess: (data) => {
      queryClient.setQueryData(courtsQueryKey(venueId), data)
      void queryClient.invalidateQueries({ queryKey: venueProfileQueryKey(venueId) })
    },
  })
}
